import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import vegan from "../components/images/vegan.svg"
import vegetarian from "../components/images/vegetarian.svg"
import nuts from "../components/images/nuts.svg"
import gluten from "../components/images/gluten.svg"
import lactose from "../components/images/lactose.svg"


import "../styles/style.scss"


const MenuTemplate = ({ data, location }) => {
  const post = data.contentfulMenuSection.dishes
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title={siteTitle} />

      <h1>{data.contentfulMenuSection.menuTitle}</h1>

      {post.map(dishes => {
        return (
          <>
            <h2>{}</h2>
            <hr />
            <div className="menu-group">
              <div class="menu-item">
                <h3>{dishes.dishName}</h3>
                <div className="dotted"></div>
                <h3>£{dishes.dishPrice}</h3>
              </div>
              <p>{dishes.dishDescription.dishDescription}</p>
              <div className="dietary-info">
                {dishes.alergens.map(info => {
                  switch (info) {
                    case "Vegan":
                      return <img src={vegan} alt="Vegan" />
                    case "Vegetarian":
                      return <img src={vegetarian} alt="Vegetarian" />
                    case "Gluten Free":
                      return <img src={gluten} alt="Gluten Free" />
                    case "Lactose Free":
                      return <img src={lactose} alt="Lactose Free" />
                    case "Contains Nuts":
                      return <img src={nuts} alt="Contains Nuts" />
                    default:
                      break
                  }
                  return "";
                })}
              </div>
            </div>

          </>
        )
      })}
    </Layout>
  )
}

export default MenuTemplate

export const pageQuery = graphql`
  query MenuBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulMenuSection(slug: {eq: $slug}) {
      menuTitle
      dishes {
        dishName
        dishPrice
        alergens
        dishDescription {
          dishDescription
        }
      }
    }
  }
`
